exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_magicWrap_2TAYp {\n  width: 100%;\n  position: relative;\n  font-size: 0;\n  overflow: hidden;\n  min-height: 1rem;\n  height: fit-content;\n}\n\n.index_magicWrap_2TAYp .index_link_1laiV {\n  position: absolute;\n  display: block;\n}\n", ""]);

// Exports
exports.locals = {
	"magicWrap": "index_magicWrap_2TAYp",
	"link": "index_link_1laiV"
};